import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { DestinationSubAccountDispatcher } from "./Variable";
import { TransferDestinationAccountPaginatedModel } from "../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountPaginatedModel";

export interface DestinationSubAccountStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: TransferDestinationAccountPaginatedModel;
}

export class DestinationSubAccountStoreStatic extends BaseStore<DestinationSubAccountStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(DestinationSubAccountDispatcher, (actionData) =>
            this.onDestinationSubAccountStoreResponse(actionData)
        );
    }

    public getLastResult(): DestinationSubAccountStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getAccounts(): TransferDestinationAccountPaginatedModel {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): DestinationSubAccountStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onDestinationSubAccountStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
